var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuitCase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29167 3.79199H2.79167C1.87119 3.79199 1.125 4.53818 1.125 5.45866V14.2087C1.125 15.1291 1.87119 15.8753 2.79167 15.8753H3.625M5.29167 3.79199V2.95866C5.29167 2.03818 6.03786 1.29199 6.95833 1.29199H9.04167C9.96214 1.29199 10.7083 2.03818 10.7083 2.95866V3.79199M5.29167 3.79199H10.7083M10.7083 3.79199H13.2083C14.1288 3.79199 14.875 4.53818 14.875 5.45866V14.2087C14.875 15.1291 14.1288 15.8753 13.2083 15.8753H12.375M3.625 15.8753V16.7087M3.625 15.8753H12.375M12.375 15.8753V16.7087M5.29167 7.12533V12.542M10.7083 7.12533V12.542",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitCase);
export default __webpack_public_path__ + "static/media/suit-case.bfe308c3d77aadd3d1da191853c32f93.svg";
export { ForwardRef as ReactComponent };